import { PROCESS } from "../data";
import { GrowthLines } from "./decor";
import { Reveal } from "./primitives";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative isolate overflow-hidden bg-white py-24 md:py-32">
    <GrowthLines className="bottom-4 right-0 w-[46%] max-w-xl opacity-70" />
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <Reveal>
        <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#5C8A1E] sm:text-base">
          How We Work
        </span>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
          A clear path from first conversation to compounding revenue.
        </h2>
      </Reveal>

      <div className="relative mt-20">
        {/* connecting line (desktop) */}
        <div className="absolute left-0 right-0 top-7 hidden h-px bg-line lg:block" />
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
          {PROCESS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative">
                  <div className="mb-6 flex items-center gap-4 lg:block">
                    <span className="relative z-10 grid h-14 w-14 place-items-center rounded-full border border-line bg-white shadow-[0_6px_28px_rgba(28,38,18,0.06)] text-[#5C8A1E]">
                      <Icon className="h-6 w-6" strokeWidth={1.8} />
                    </span>
                    <span className="font-serif text-4xl font-semibold text-[#d9dfcd] lg:mt-4 lg:block">
                      {p.step}
                    </span>
                  </div>
                  <h3 className="font-serif text-lg font-medium text-[#23271F]">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#586150]">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
